import { FormGroup } from "@angular/forms";

export class Utils {
  static GetProvider(value?: string) {
    if (!value) return 0;
    switch (value) {
      case "amazon":
        return 1;
      case "shein":
        return 2;
      case "walmart":
        return 3;
      case "homedepot":
        return 4;
      case "bestbuy":
        return 5;
      default:
        0;
    }
  }
  static GetProviderName(value?: number) {
    if (!value) return 0;
    switch (value) {
      case 1:
        return "amazon";
      case 2:
        return "shein";
      case 3:
        return "walmart";
      case 4:
        return "homedepot";
      case 5:
        return "bestbuy";
      default:
        0;
    }
  }
}
